export const CtaObjectConstants = {
    dataCta: "data-cta",
    dataCtaCategory: "data-cta-category"
}